import { render, staticRenderFns } from "./ReleaseInformation.vue?vue&type=template&id=eedae920"
import script from "./ReleaseInformation.vue?vue&type=script&lang=js"
export * from "./ReleaseInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports